import { render } from "./home.vue?vue&type=template&id=b00619e0"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=b00619e0&lang=css"

import exportComponent from "C:\\Users\\loong\\develop\\project\\tianyuan\\ty-maintain-web\\ty-maintain-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__